import { ReactNode } from "react";
import { Flex, Color, Text, HorizontalDivider, Toggle } from "src/elements";

interface Props {
  title: string;
  area: string;
  width?: string;
  toggleValue?: boolean;
  setToggleValue?: (value: boolean) => void;
  isDisabled?: boolean;
  children?: ReactNode;
}

export const RulesSection = ({
  title,
  area,
  width = "100%",
  toggleValue,
  setToggleValue,
  isDisabled,
  children,
}: Props) => {
  return (
    <Flex
      width={width}
      background={Color.lightGray}
      column
      borderRadius="3px"
      overflow="hidden"
      gridArea={area}
    >
      <Flex
        background={Color.lightGrayHover}
        padding="5px 10px"
        justify="center"
        align="center"
        gap="10px"
      >
        <Text variant="body1" color={(isDisabled && Color.textDisabled) || Color.textMain}>
          {title}
        </Text>

        {toggleValue !== undefined && setToggleValue !== undefined && (
          <Toggle value={toggleValue} setValue={setToggleValue} isDisabled={isDisabled} />
        )}
      </Flex>

      <HorizontalDivider color={Color.textDisabled} />

      <Flex column>{children}</Flex>
    </Flex>
  );
};
